const DATEMIN_SLASH_FORMAT = 'DD/MM/YYYY';
const DATE_SLASH_FORMAT = 'DD/MM/YYYY HH:mm:ss';
const DATE_NOSLASH_FORMAT = 'YYYYMMDD';
const MONTH_NOSLASH_FORMAT = 'YYYYMM';
const MONTH_SLASH_FORMAT = 'MM/YYYY';
const DATE_TIMEZONE = 'Asia/Ho_Chi_Minh';
const YEAR_DASH_FORMAT = 'YYYY-MM-DD';
const VN_DATE_SLASH_FORMAT = 'HH:mm:ss DD/MM/YYYY';
const DATEMIN_DASH_FORMAT = 'DD-MM-YYYY';
const DATE_DASH_FORMAT = 'DD-MM-YYYY HH:mm:ss';
const DATE_DASH_ISO_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export default {
  DATE_SLASH_FORMAT,
  DATEMIN_SLASH_FORMAT,
  DATE_NOSLASH_FORMAT,
  DATE_TIMEZONE,
  MONTH_NOSLASH_FORMAT,
  MONTH_SLASH_FORMAT,
  YEAR_DASH_FORMAT,
  VN_DATE_SLASH_FORMAT,
  DATEMIN_DASH_FORMAT,
  DATE_DASH_FORMAT,
  DATE_DASH_ISO_FORMAT,
};
